import isValidUrl from './url-validator';

export const checkUri = (uri, name) => {
  if (!isValidUrl(uri)) {
    throw new Error(`Invalid url for services ${name} request`);
  }
};

export default {};
